var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRlefLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 65,
    viewBox: "0 0 424 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1346_22419)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1346_22419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9788 15.8982C22.3446 15.8982 22.6931 15.7588 22.9806 15.5236C26.8571 12.2307 31.8835 10.2358 37.3543 10.2358C42.1716 10.2358 46.7364 11.7429 50.5868 14.6002C52.6252 16.1073 55.4738 16.0985 57.3119 14.3476C59.6727 12.1 59.3765 8.39773 56.8851 6.52479C51.214 2.25624 44.4627 0 37.3543 0C26.5348 0 16.9436 5.32263 11.0373 13.4764C10.3056 14.4869 11.0373 15.8982 12.2918 15.8982H21.9788Z",
    fill: "url(#paint0_linear_1346_22419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9908 21.5431C79.9436 19.5918 76.703 19.6615 74.7517 21.7086C73.7238 22.7801 71.7898 25.2019 68.4621 29.3833C63.2701 35.9081 54.5762 46.8147 51.1788 49.55C47.8511 52.2244 43.8787 54.7071 37.3626 54.7071C30.8466 54.7071 25.0535 51.9195 20.9853 47.4854C20.6892 47.1631 20.2797 46.9715 19.8441 46.9715H10.9325C9.739 46.9715 8.98983 48.2782 9.61705 49.2974C15.323 58.6708 25.6285 64.943 37.3714 64.943C47.1368 64.943 53.3131 60.9793 57.6078 57.5209C61.5627 54.3326 68.4969 45.778 76.4852 35.7513C78.907 32.711 81.4158 29.5575 82.1737 28.7648C84.1251 26.7176 84.0554 23.477 82.0082 21.5257L81.9908 21.5431Z",
    fill: "url(#paint1_linear_1346_22419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.268 35.262C125.229 28.4786 120.509 22.2009 113.725 21.2403C106.942 20.2797 100.664 25 99.7037 31.7834C98.7431 38.5668 103.463 44.8445 110.247 45.8051C117.03 46.7657 123.308 42.0454 124.268 35.262Z",
    fill: "#004047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.499 49.0447C103.133 49.0447 102.785 49.1841 102.497 49.4193C98.6209 52.7122 93.5944 54.707 88.1237 54.707C83.3063 54.707 78.7416 53.2 74.8912 50.3427C72.8527 48.8356 70.0041 48.8443 68.166 50.5953C65.8053 52.8428 66.1015 56.5451 68.5929 58.4181C74.264 62.6866 81.0153 64.9516 88.1237 64.9516C98.9432 64.9516 108.534 59.629 114.441 51.4751C115.172 50.4646 114.441 49.0534 113.186 49.0534H103.499V49.0447Z",
    fill: "url(#paint2_linear_1346_22419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4871 43.3999C45.5343 45.3512 48.7749 45.2815 50.7263 43.2343C51.7542 42.1629 53.6881 39.7411 57.0158 35.5597C62.2078 29.0349 70.9017 18.1283 74.2991 15.3929C77.6269 12.7186 81.5992 10.2358 88.1153 10.2358C94.6314 10.2358 100.424 13.0234 104.493 17.4575C104.789 17.7798 105.198 17.9715 105.634 17.9715H114.545C115.739 17.9715 116.488 16.6648 115.861 15.6456C110.155 6.27217 99.8495 0 88.1066 0C78.3412 0 72.1649 3.96366 67.8702 7.42206C63.9152 10.6104 56.981 19.1649 48.9927 29.1917C46.571 32.2319 44.0621 35.3854 43.3042 36.1782C41.3529 38.2253 41.4226 41.466 43.4697 43.4173L43.4871 43.3999Z",
    fill: "url(#paint3_linear_1346_22419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7134 45.9872C11.6122 39.5844 6.41154 34.3837 0 31.2737C6.40283 28.1725 11.6035 22.9718 14.7134 16.5603C17.8147 22.9631 23.0153 28.1638 29.4269 31.2737C23.024 34.375 17.8234 39.5756 14.7134 45.9872Z",
    fill: "#008D9C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.98 38.6131V61.4629H146.915V4.36884H172.004C184.452 4.36884 191.151 11.2246 191.151 20.0405C191.151 27.7065 186.978 31.8531 182.858 33.5518C185.689 34.5972 189.949 37.5416 189.949 47.76V50.5824C189.949 54.4241 189.984 58.7972 190.768 61.4629H179.069C178.067 58.9802 177.875 54.7029 177.875 48.6398V47.8035C177.875 41.5575 176.298 38.6044 167.099 38.6044H158.98V38.6131ZM158.98 28.7867H169.329C176.089 28.7867 178.694 26.2168 178.694 21.443C178.694 16.6692 175.662 14.2039 169.625 14.2039H158.98V28.7954V28.7867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.862 4.36005H212.206V51.3403H240.649L239.238 61.4628H199.862V4.36875V4.36005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.64 36.836H261.338V51.3403H291.462L289.999 61.4629H249.36V4.36884H289.842V14.4914H261.338V26.7221H288.64V36.8447V36.836Z",
    fill: "url(#paint4_linear_1346_22419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.173 4.36005H340.028V14.4826H312.23V28.473H338.268V38.5956H312.23V61.4628H300.173V4.36875V4.36005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.739 61.4628V50.7827H352.877V61.4628H348.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.514 41.418L366.144 61.4628H361.588L382.87 3.48889H388.167L410.363 61.4628H405.476L397.941 41.418H373.514ZM396.451 37.2714C389.996 20.0491 386.677 11.7647 385.518 7.87069H385.431C384.02 12.2612 380.3 22.5319 375.082 37.2714H396.451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.544 3.48889V61.4628H419.075V3.48889H423.544Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1346_22419",
    x1: 10.7499,
    y1: 7.94474,
    x2: 58.9322,
    y2: 7.94474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1346_22419",
    x1: 9.37313,
    y1: 42.5374,
    x2: 83.5763,
    y2: 42.5374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1346_22419",
    x1: 114.728,
    y1: 56.9981,
    x2: 66.5457,
    y2: 56.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1346_22419",
    x1: 122.36,
    y1: 22.4055,
    x2: 48.1564,
    y2: 22.4055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1346_22419",
    x1: 270.407,
    y1: 4.36012,
    x2: 270.407,
    y2: 61.4542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#00828F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#00636D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1346_22419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 423.543,
    height: 64.9517,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1346_22419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.008,
    height: 64.9517,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRlefLogo);
export default __webpack_public_path__ + "static/media/RLEF-Logo.b9658fc0cb7739d2a1b4f568fbdef0a8.svg";
export { ForwardRef as ReactComponent };